module.exports = __webpack_public_path__ + "img/dirt-7.49207df1.png";